module.exports = __webpack_public_path__ + "img/top3.ff6a4e9a.png";